import { render, staticRenderFns } from "./index.vue?vue&type=template&id=726f17db&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=726f17db&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726f17db",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('726f17db')) {
      api.createRecord('726f17db', component.options)
    } else {
      api.reload('726f17db', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=726f17db&scoped=true", function () {
      api.rerender('726f17db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ReportManagement/staticAgingMonitoring/index.vue"
export default component.exports